import React, { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Sidebar.css';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const sidebar = document.querySelector('.sidebar');
      const mobileMenuButton = document.querySelector('.mobile-menu-button');
      
      if (isOpen && 
          sidebar && 
          !sidebar.contains(event.target as Node) && 
          mobileMenuButton && 
          !mobileMenuButton.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleLogout = () => {
    // Clear any stored session data
    localStorage.removeItem('user');
    sessionStorage.clear();
    
    // Redirect to login page
    navigate('/', { replace: true });
  };

  const handleNavClick = () => {
    if (window.innerWidth <= 768) {
      onClose();
    }
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <h2>CMS Admin</h2>
      </div>
      <nav className="sidebar-nav">
        <Link 
          to="/admin/dashboard" 
          className={`nav-item ${location.pathname === '/admin/dashboard' ? 'active' : ''}`}
          onClick={handleNavClick}
        >
          Dashboard
        </Link>
        <Link 
          to="/admin/rss" 
          className={`nav-item ${location.pathname === '/admin/rss' ? 'active' : ''}`}
          onClick={handleNavClick}
        >
          RSS Management
        </Link>
        <Link 
          to="/admin/news" 
          className={`nav-item ${location.pathname === '/admin/news' ? 'active' : ''}`}
          onClick={handleNavClick}
        >
          News Management
        </Link>
        <Link 
          to="/admin/topics" 
          className={`nav-item ${location.pathname === '/admin/topics' ? 'active' : ''}`}
          onClick={handleNavClick}
        >
          Topic Management
        </Link>
        <Link 
          to="/admin/hot-topics" 
          className={`nav-item ${location.pathname === '/admin/hot-topics' ? 'active' : ''}`}
          onClick={handleNavClick}
        >
          Hot Topics Management
        </Link>
        <Link 
          to="/admin/countries" 
          className={`nav-item ${location.pathname === '/admin/countries' ? 'active' : ''}`}
          onClick={handleNavClick}
        >
          Country Management
        </Link>
        <Link 
          to="/admin/users" 
          className={`nav-item ${location.pathname === '/admin/users' ? 'active' : ''}`}
          onClick={handleNavClick}
        >
          Users
        </Link>
        <Link 
          to="/admin/fcm" 
          className={`nav-item ${location.pathname === '/admin/fcm' ? 'active' : ''}`}
          onClick={handleNavClick}
        >
          FCM Management
        </Link>
        <Link 
          to="/admin/settings" 
          className={`nav-item ${location.pathname === '/admin/settings' ? 'active' : ''}`}
          onClick={handleNavClick}
        >
          Settings
        </Link>
      </nav>
      <div className="sidebar-footer">
        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar; 